import { Component, type ReactNode } from 'react'
import { PageCrashed } from './PageCrashed'
import { reportCrash } from '../lib/reportCrash'

interface Props {
  // resetKey: the boundary clears its error when this changes (the pathname).
  resetKey: string
  children: ReactNode
}

interface State {
  error: unknown
  hasError: boolean
}

// PageErrorBoundary confines a crash in the root route's children to the
// content area, and clears it on navigation.
export class PageErrorBoundary extends Component<Props, State> {
  state: State = { error: null, hasError: false }

  static getDerivedStateFromError(error: unknown): State {
    return { error, hasError: true }
  }

  componentDidCatch(error: unknown) {
    reportCrash(error)
  }

  componentDidUpdate(prev: Props) {
    if (this.state.hasError && prev.resetKey !== this.props.resetKey) {
      this.setState({ error: null, hasError: false })
    }
  }

  render() {
    if (this.state.hasError) return <PageCrashed error={this.state.error} />
    return this.props.children
  }
}
